import { Unlink } from "@wix/wix-ui-icons-common";
import React, { useContext } from "react";
import { RicosContext } from "./../../ricos-context/index.js";
import { ToolbarButton } from "./../../_shared/toolbar-button/toolbar-button.js";
const UnlinkButton = ({ toolbarItem, dataHook }) => {
  const { t } = useContext(RicosContext) || {};
  return /* @__PURE__ */ React.createElement(
    ToolbarButton,
    {
      prefix: Unlink,
      onClick: () => toolbarItem.commands?.click(),
      dataHook,
      tooltip: t("LinkPreview_Unlink_Tooltip")
    }
  );
};
export {
  UnlinkButton
};
//# sourceMappingURL=UnlinkButton.js.map
